<template>
  <header class="l-block__header">
    <p class="c-title__register">
      <router-link v-if="logoLinkTo" :to="logoLinkTo">
        <img
          src="@/assets/img/logo.svg"
          :alt="$constants.siteName"
          class="c-title__register-image"
        />
      </router-link>
      <img
        v-else
        src="@/assets/img/logo.svg"
        :alt="$constants.siteName"
        class="c-title__register-image"
      />
    </p>
    <slot></slot>
  </header>
</template>

<script>
export default {
  components: {},

  computed: {
    logoLinkTo() {
      let to = null;
      if (!this.requiresAuth) {
        to = { name: 'login' };
      } else if (this.hasProject) {
        // サイトがない時はsetに強制リダイレクトされるため、projectsにリンクしないようにする
        to = { name: 'projects' };
      }
      return to;
    },
    requiresAuth() {
      return this.$route.matched.some(record => record.meta.requiresAuth);
    },
    hasProject() {
      return this.$store.getters['user/hasProject'];
    }
  }
};
</script>
